import React, { useEffect, useState } from 'react';
import { ClockIcon } from 'lucide-react';
export function UrgencyBar() {
  const [timeLeft, setTimeLeft] = useState(12 * 60 + 45); // 12:45 in seconds
  useEffect(() => {
    if (timeLeft <= 0) return;
    const timer = setInterval(() => {
      setTimeLeft(prev => Math.max(0, prev - 1));
    }, 1000);
    return () => clearInterval(timer);
  }, [timeLeft]);
  const minutes = Math.floor(timeLeft / 60);
  const seconds = timeLeft % 60;
  return <div className="fixed top-0 left-0 right-0 z-50 bg-gradient-to-r from-red-900 to-red-800 text-white py-3 px-4 shadow-lg" data-id="element-217">
      <div className="max-w-7xl mx-auto flex items-center justify-center gap-3 text-sm md:text-base font-semibold" data-id="element-218">
        <ClockIcon className="w-5 h-5 animate-pulse" data-id="element-219" />
        <span className="text-center" data-id="element-220">
          OFERTA DE LANZAMIENTO: 90% DE DESCUENTO FINALIZA CUANDO EL CONTADOR
          LLEGUE A CERO.{' '}
          <span className="inline-block bg-black/30 px-3 py-1 rounded ml-2 font-mono text-lg" data-id="element-221">
            {String(minutes).padStart(2, '0')}:
            {String(seconds).padStart(2, '0')}
          </span>
        </span>
      </div>
    </div>;
}